import type { TimelineActionButtonContextT } from './types'

export const TIMELINE_ACTION_BUTTON_INITIAL_VALUES: TimelineActionButtonContextT = {
  messageDrawerProps: undefined,
  dialogProps: undefined,
  setMessageDrawerProps: () => {},
  setDialogProps: () => {},
  setIsBalanceDrawerOpen: () => {},
  isBalanceDrawerOpen: false,
  setAbsencePlannerDrawerProps: () => {},
}
